import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { EventBus } from "../../../Controls/EventBus";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";
import { AbsenceSalarieDto } from "../../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import EventConstants from "../../../Controls/EventConstants";
import ModalChangerEtatAbsence from "../../modals/modalChangerEtatAbsence/modalChangerEtatAbsence";
import { EtatAbsencesEnum } from "../../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { ActionAbsencesEnum } from "../../../../dto/GenApi.iNotPaie.Dto/ActionAbsencesEnum";

@Component({
	components: {
		DemandeEnAttenteComponent: require("./tableaux/demandeEnAttente/demandeEnAttente.vue.html"),
		AnnulationEnAttenteComponent: require("./tableaux/annulationEnAttente/annulationEnAttente.vue.html")
	}
})
export default class EspaceManager extends Vue {
	public switchType = false;
	public dataReady = false;
	public compteurAbsenceEnAttente = 0;
	public compteurAbsenceAnnulation = 0;
	public listAbsenceEmployes: AbsenceSalarieDto[] = [];
	public demandeEnAttente: AbsenceSalarieDto[] = [];
	public annulationEnAttente: AbsenceSalarieDto[] = [];

	@Prop()
	public modalChangerEtatAbsence?: ModalChangerEtatAbsence = undefined;

	public mounted(): void {
    	EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
    		this.fetchData();
    	});
	}

	public switchOngletType(): void {
    	this.switchType = !this.switchType;
	}

	public fetchData(): void {
		this.dataReady = false;

		ServicesFactoryInstance.AbsencesService.getAbsencesEnAttenteDeValidation(data => {
    		this.listAbsenceEmployes = data;

			// Listes
			this.demandeEnAttente = this.listAbsenceEmployes.filter(x => x.Etat == EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1 || x.Etat == EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2);
			this.annulationEnAttente = this.listAbsenceEmployes.filter(x => x.Etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1 || x.Etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2);

    		// Compteurs
			this.compteurAbsenceEnAttente = this.demandeEnAttente.length;
			this.compteurAbsenceAnnulation = this.annulationEnAttente.length;

    		this.dataReady = true;
    	});
	}

	public afficherModalChangerEtatAbsence(absence: AbsenceSalarieDto, action: ActionAbsencesEnum): void {
		this.$emit("afficherModalChangerEtatAbsence", absence, action);
	}

	public afficherModalDetailAbsence(data: any): void {
    	const absence = data.absence;
    	this.$emit("afficherModalDetailAbsence", { absence });
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/listeDesDemandes/espaceManager/espaceManager.ts